import React from 'react'

import {Link} from 'react-router-dom'
 
function Nav() {
  return (
    <>
      {/* <!-- Header Start --> */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-3 bg-secondary d-none d-lg-block">
            <Link to="/" className="navbar-brand w-100 h-100 m-0 p-0 d-flex align-items-center justify-content-center">
              <h1 className="m-0 display-3 text-primary">Klean</h1>
            </Link>
          </div>
          <div className="col-lg-9">
            <div className="row bg-dark d-none d-lg-flex">
              <div className="col-lg-7 text-left text-white">
                <div className="h-100 d-inline-flex align-items-center border-right border-primary py-2 px-3">
                  <i className="fa fa-envelope text-primary mr-2"></i>
                  <small>info@example.com</small>
                </div>
                <div className="h-100 d-inline-flex align-items-center py-2 px-2">
                  <i className="fa fa-phone-alt text-primary mr-2"></i>
                  <small>+012 345 6789</small>
                </div>
              </div>
              <div className="col-lg-5 text-right">
                <div className="d-inline-flex align-items-center pr-2">
                  <Link className="text-primary p-2" to="">
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                  <Link className="text-primary p-2" to="">
                    <i className="fab fa-twitter"></i>
                  </Link>
                  <Link className="text-primary p-2" to="">
                    <i className="fab fa-linkedin-in"></i>
                  </Link>
                  <Link className="text-primary p-2" to="">
                    <i className="fab fa-instagram"></i>
                  </Link>
                  <Link className="text-primary p-2" to="">
                    <i className="fab fa-youtube"></i>
                  </Link>
                </div>
              </div>
            </div>
            <nav className="navbar navbar-expand-lg bg-white navbar-light p-0">
              <Link to="" className="navbar-brand d-block d-lg-none">
                <h1 className="m-0 display-4 text-primary">Klean</h1>
              </Link>
              <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse justify-content-between" id="navbarCollapse">
                <div className="navbar-nav mr-auto py-0">
                  <Link to="/" className="nav-item nav-link active">Home</Link>
                  <Link to="/about" className="nav-item nav-link">About</Link>
                  <Link to="/contact" className="nav-item nav-link">Contact</Link>
                  <Link to="/service" className="nav-item nav-link">Service</Link>
                  {/* <Link to="project.html" className="nav-item nav-link">Project</Link>
                  <div className="nav-item dropdown">
                    <Link to="#" className="nav-link dropdown-toggle" data-toggle="dropdown">Pages</Link>
                    <div className="dropdown-menu rounded-0 m-0">
                      <Link to="blog.html" className="dropdown-item">Latest Blog</Link>
                      <Link to="single.html" className="dropdown-item">Blog Detail</Link>
                    </div>
                  </div> */}
                
                </div>
                <Link to="" className="btn btn-primary mr-3 d-none d-lg-block">Get A Quote</Link>
              </div>
            </nav>
          </div>
        </div>
      </div>
      {/* <!-- Header End --> */}

    </>
  )
}

export default Nav